export const DOCUMENT_TYPE_ACTIONS = {
    "1": "ATH",
    "2": "Bills Of Landing",
    "12": "Credit",
    "3": "Customer",
    "4": "Deleted After Import",
    "5": "EDI",
    "6": "Invoice",
    "10": "Manifest",
    "7": "Miscellaneous",
    "8": "No Document Type",
    "9": "Proof Of Delivery",
    "11": "Unknown",
    "13": "Warehouse Receipt"
  };
  export const DOCUMENT_TYPE_ID_ACTIONS = {
    "1": "ATH",
    "2": "BOL",
    "12": "CRT",
    "3": "CUS",
    "4": "DAI",
    "5": "EDI",
    "6": "INV",
    "10": "MAN",
    "7": "MSC",
    "8": "NDT",
    "9": "POD",
    "11": "UNK",
    "13": "WHR"
  };
  export const DOCUMENT_STAT_ID_ACTIONS = {
    "1": "N",
    "2": "A",
    "3": "R",
    "4": "M",
    "5": "P",
    "6": "D",
    "10": "IN",
    "7": "X",
    "8": "IR",
    "9": "I",
    "11": "MIA"
  };
  export const LOCATION_ACTIONS = {
    "170": "ABQ - ALBUQUERQUE",
    "620": "ABE - ALLENTOWN",
    "109": "ANA - ANAHEIM",
    "189": "BWI - BALTIMORE",
    "704": "CLT - CHARLOTTE",
    "2": "CHA - CHATTANOOGA",
    "77": "ORD - CHICAGO",
    "946": "CLE - CLEVELAND",
    "351": "WOR - CLINTON",
    "4": "DFW - DALLAS",
    "944": "DAY - DAYTON",
    "106": "DEN - DENVER",
    "625": "DTW - DETROIT",
    "642": "GRR - GRAND RAPIDS",
    "150": "IAH - HOUSTON",
    "624": "IND - INDIANAPOLIS",
    "119": "JAX - JACKSONVILLE",
    "384": "SEA - KENT",
    "863": "LAL - LAKELAND",
    "156": "SDF - LOUISVILLE",
    "305": "MIA - MIAMI",
    "192": "MKE - MILWAUKEE",
    "197": "MSP - MINNEAPOLIS",
    "504": "MSY - NEW ORLEANS",
    "188": "OKC - OKLAHOMA CITY",
    "75": "PHX - PHOENIX",
    "20": "PIT - PITTSBURGH",
    "159": "PDX - PORTLAND",
    "145": "ROC - ROCHESTER",
    "37": "SAC - SACRAMENTO",
    "153": "STL - SAINT LOUIS",
    "47": "SLC - SALT LAKE CITY",
    "17": "SAT - SAN ANTONIO",
    "26": "SAN - SAN DIEGO",
    "51": "GEG - SPOKANE",
    "611": "SGF - SPRINGFIELD",
    "209": "TCY - TRACY",
    "1": "THL - TUNNEL HILL",
    "205": "YNG - YOUNGSTOWN"
  };
  export const STATUS_ACTIONS = {
    "2": "Auto Indexed",
    "6": "Deleted",
    "8": "Import Review",
    "9": "Imported",
    "10": "Inspected",
    "4": "Manually Indexed",
    "11": "Missing",
    "1": "New",
    "5": "Passed",
    "7": "Purge",
    "3": "Review"
  };